import { loadTypeSol, loadCulture, loadCulturePrec, loadTypeMateriel, loadStade, loadCultureStade, loadVariete, loadAgence, loadTypeSource, loadPrixEau } from '@/api/client-api'

const initialState = {
  typeSol: [],
  cultures: [],
  culturesPrec: [],
  typeMateriel: [],
  stade: [],
  cultureStade: [],
  varietes: [],
  agences: [],
  typeSource: [],
  prixEau: []
}

const state = Object.assign({}, initialState)

const mutations = {
  'TYPE_SOL': (state, typeSol) => {
    state.typeSol = typeSol
  },
  'CULTURES': (state, cultures) => {
    state.cultures = cultures
  },
  'CULTURES_PREC': (state, culturesPrec) => {
    state.culturesPrec = culturesPrec
  },
  'TYPE_MATERIEL': (state, typeMateriel) => {
    state.typeMateriel = typeMateriel
  },
  'STADE': (state, stade) => {
    state.stade = stade
  },
  'CULTURE_STADE': (state, cultureStade) => {
    state.cultureStade = cultureStade
  },
  'VARIETES': (state, varietes) => {
    state.varietes = varietes
  },
  'AGENCES': (state, agences) => {
    state.agences = agences
  },
  'TYPE_SOURCE': (state, typeSource) => {
    state.typeSource = typeSource
  },
  'PRIX_EAU': (state, prixEau) => {
    state.prixEau = prixEau
  }
}

const actions = {
  loadTypeSols: ({ commit, state }) => {
    if (state.typeSol.length === 0) {
      loadTypeSol().then(typeSol => commit('TYPE_SOL', typeSol))
    }
  },
  loadCultures: ({ commit, state }) => {
    if (state.cultures.length === 0) {
      loadCulture().then(cultures => commit('CULTURES', cultures))
    }
  },
  loadCulturePrecs: ({ commit, state }) => {
    if (state.culturesPrec.length === 0) {
      loadCulturePrec().then(culturesPrec => commit('CULTURES_PREC', culturesPrec))
    }
  },
  loadTypeMateriels: ({ commit, state }) => {
    if (state.typeMateriel.length === 0) {
      loadTypeMateriel().then(typeMateriel => commit('TYPE_MATERIEL', typeMateriel))
    }
  },
  loadStades: ({ commit, state }) => {
    if (state.stade.length === 0) {
      loadStade().then(stade => commit('STADE', stade))
    }
  },
  loadCultureStades: ({ commit, state }) => {
    if (state.cultureStade.length === 0) {
      loadCultureStade().then(cultureStade => commit('CULTURE_STADE', cultureStade))
    }
  },
  loadVarietes: ({ commit, state }) => {
    if (state.varietes.length === 0) {
      loadVariete().then(varietes => commit('VARIETES', varietes))
    }
  },
  loadPrixEau: ({ commit, state }) => {
    return new Promise((resolve, reject) => {
      let promises = []
      if (state.agences.length === 0) {
        promises.push(loadAgence().then(agences => commit('AGENCES', agences)))
      }
      if (state.typeSource.length === 0) {
        promises.push(loadTypeSource().then(typeSource => commit('TYPE_SOURCE', typeSource)))
      }
      if (state.prixEau.length === 0) {
        promises.push(loadPrixEau().then(prixEau => commit('PRIX_EAU', prixEau)))
      }
      return Promise.all(promises).then(() => resolve()).catch(reject)
    })
  }
}

const getters = {
  getStadeNom: state => idStade => {
    let stade = state.stade.find(s => s.id_ref_stade === idStade)
    return stade ? stade.nom : false
  },
  getStadeOrdre: state => idStade => {
    let stade = state.cultureStade.find(s => s.id_ref_stade === idStade)
    return stade ? stade.ordre : false
  },
  getStadesByCulture: (state, getters) => idCulture => {
    return state.cultureStade
      .filter(stade => stade.id_ref_culture === idCulture)
      .map(stade => {
        return {
          id_ref_stade: stade.id_ref_stade,
          ordre: stade.ordre,
          nom: getters.getStadeNom(stade.id_ref_stade)
        }
      })
  },
  getVarietesByCulture: (state, getters) => idCulture => {
    return state.varietes
      .filter(variete => variete.id_ref_culture === idCulture)
  },
  getVarietesForLocalCulture: (state, getters) => idCulture => {
    let varietes = getters.getVarietesByCulture(idCulture)
    let refCulture = state.cultures.find(c => c.id_ref_culture === idCulture)

    if (refCulture !== undefined && refCulture.has_variete) {
      return varietes.sort((v1, v2) => v1.nom.localeCompare(v2.nom))
    }
    return varietes
  },
  getVarieteById: state => idRefVariete => {
    return state.varietes.find(v => v.id_ref_variete === idRefVariete)
  },
  getTypeSolByIds: state => ids => {
    return state.typeSol
      .filter(typeSol => ids.indexOf(typeSol.id_ref_type_sol) !== -1)
  },
  getCulturePrecedenteById: state => idCulturePrecedente => {
    return state.culturesPrec.find(c => c.id_culture_precedente === idCulturePrecedente)
  },
  getMaterielByIlot: state => idRefTypeMateriel => {
    let mat = state.typeMateriel
      .find(m => m.id_ref_type_materiel === idRefTypeMateriel)
    return mat ? mat.nom : false
  },
  getPrixById: state => id => {
    return state.prixEau.find(p => (p.id_ref_prix_eau === id))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
